import React from "react";
import { useNavigate } from "react-router-dom";

const LandingPage = () => {
  const navigate = useNavigate();

  const handleNavigate = () => {
    navigate("/dashboard");
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-6 bg-transparent text-yellow-200">
      <div className="bg-white/10 backdrop-blur-md border border-white/20 p-10 rounded-2xl max-w-3xl w-full text-center shadow-2xl">
        {/* Title */}
        <h1 className="text-4xl sm:text-5xl font-extrabold text-yellow-400 tracking-wide drop-shadow mb-4">
          Smart Maheshwari Matrimony
        </h1>

        {/* Subheading */}
        <p className="text-lg sm:text-xl text-gray-300 font-light mb-6">
          A modern matchmaking platform built on values, trust, and intelligent compatibility.
        </p>

        {/* Button */}
        <button
          onClick={handleNavigate}
          className="bg-yellow-400 hover:bg-yellow-300 text-black font-semibold px-8 py-3 rounded-full shadow-lg transition-all duration-300"
        >
          🚀 Go to Dashboard
        </button>
      </div>
    </div>
  );
};

export default LandingPage;
